<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>新增成交项目</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">新增成交项目</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="100px" :inline="false" size="small">
        <div class="divContainer">

          <!-- 左边部分 -->
          <div class="leftDiv">
            <!-- 签约类型 -->
            <el-form-item label="签约类型：" prop="signType">
              <el-select v-model="form.signType" placeholder="请选择签约类型" style="width: 100%" @change="onSignTypeChange">
                <el-option v-for="item in signTypeList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <!-- 项目名称 -->
            <el-form-item label="项目名称：" prop="projectName">
              <el-input v-model="form.projectName" :placeholder="form.signType === '其他' ? '输入项目名称' : '品牌名+地标，如美滋滋西安钟楼店'" maxlength="50"></el-input>
            </el-form-item>

            <!-- 客户信息 -->
            <el-form-item label="客户：" prop="customerId">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>

            <!-- 签约人 -->
            <el-form-item label="签约人：" prop="signerId">
              <el-select :disabled="isSignerReadonly" v-model="form.signerId" placeholder="请选择签约人" style="width: 100%"
                @change="onSignerChange">
                <el-option v-for="item in employeeList" :key="item._id" :label="item.name"
                  :value="item._id"></el-option>
              </el-select>
            </el-form-item>

            <!-- 签约时间 -->
            <el-form-item label="签约时间：" prop="dealDate">
              <el-date-picker v-model="form.dealDate" type="date" placeholder="请选择签约时间" style="width: 50%;margin-right:5px"
                value-format="yyyy-MM-dd" format="yyyy/MM/dd">
              </el-date-picker>
              <el-button plain type="primary" size="mini" @click="getYesterday('dealDate')">昨天</el-button>
              <el-button plain type="primary" size="mini" @click="getToday('dealDate')">今天</el-button>
            </el-form-item>

            <!-- 地址 -->
            <el-form-item v-if="!isOtherType" label="地址：" prop="address">
              <div>
                <el-input v-model="form.address" placeholder="请输入地址" maxlength="100"
                  style="width:70%;margin-right:5px"></el-input>
                <el-button type="primary" size="small" @click="locateClickHandler">定位</el-button>
              </div>
              <div v-if="form.province && form.city && form.district">
                <div class="descText">{{ form.area }} {{ form.province }}-{{ form.city }}-{{ form.district }}
                  [{{ form.lat }}/{{ form.lng }}]</div>
              </div>
            </el-form-item>

            <!-- 督导 -->
            <el-form-item v-if="!isOtherType" label="督导：" prop="supervisorId">
              <el-select v-model="form.supervisorId" placeholder="请选择督导" style="width: 100%"
                @change="onSupervisorChange">
                <el-option v-for="item in supervisorList" :key="item._id" :label="item.name"
                  :value="item._id"></el-option>
              </el-select>
            </el-form-item>

            <!-- 商圈范围 -->
            <el-form-item v-if="!isOtherType" label="商圈范围：" prop="range">
              <el-input-number v-model="form.range" :min="0.1" :max="50" :precision="1" :step="0.5"
                style="width: 150px"></el-input-number>
              <span style="margin-left: 10px; color: #909399;">公里</span>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="项目备注：" prop="remark">
              <el-input v-model="form.remark" type="textarea" placeholder="与项目或老板相关的备注信息（最多500字符）。比如：这是老板的二店。再比如：老板说先锁定商圈，后面再决定何时开张。" maxlength="500"
                rows="5"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :loading="submitting" @click="okClickHandler" size="normal">添加项目</el-button>
              <el-button @click="goBack" size="normal">返回</el-button>
            </el-form-item>
          </div>

          <!-- 中间部分 -->
          <div class="midDiv">
            <!-- 合同金额 -->
            <el-form-item label="合同金额：" prop="contractAmount">
              <el-input-number v-model="form.contractAmount" :min="0" :step="100" placeholder="请输入金额"
                style="width: 150px"></el-input-number>
            </el-form-item>

            <!-- 抽佣比例 -->
            <el-form-item v-if="!isOtherType" label="抽佣比例：" prop="commissionRate">
              <el-input-number v-model="form.commissionRate" :min="0" :max="100" :precision="1" :step="0.5" placeholder="请输入抽佣比例" style="width: 150px"></el-input-number>
              <span style="margin-left: 10px; color: #909399;">%</span>
            </el-form-item>

            <!-- 合同期限 -->
            <el-form-item label="合同期限：" prop="serviceDateRange">
              <div style="display: flex; align-items: center;">
                <el-date-picker
                  v-model="form.serviceStartDate"
                  type="date"
                  placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy/MM/dd"
                  @change="validateServiceDateRange"
                  style="width: 100%">
                </el-date-picker>
                <span style="margin: 0 10px;">至</span>
                <el-date-picker
                  v-model="form.serviceEndDate"
                  type="date"
                  placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy/MM/dd"
                  @change="validateServiceDateRange"
                  style="width: 100%">
                </el-date-picker>
              </div>
            </el-form-item>

            <!-- 合同备注 -->
            <el-form-item label="合同备注：" prop="contractRemark">
              <el-input v-model="form.contractRemark" type="textarea" placeholder="合同的备忘、补充或其他约定。如：0元二店合同。再比如：合同签订日期延迟一个月。" maxlength="500"
                rows="3"></el-input>
            </el-form-item>

            <!-- 收款金额 -->
            <el-form-item label="收款金额：" prop="totalAmount">
              <el-input-number v-model="form.totalAmount" :min="0" :step="100" placeholder="请输入金额"
                style="width: 150px"></el-input-number>
            </el-form-item>

            <!-- 钱款类型 -->
            <el-form-item v-if="!isOtherType" label="钱款类型：" prop="payType">
              <el-radio-group v-model="form.payType" size='mini'>
                <el-radio-button v-for="item in payTypeList" :key="item" :label="item">{{ item }}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <!-- 收款账户 -->
            <el-form-item label="收款账户：" prop="payAccount">
              <el-select v-model="form.payAccount" placeholder="请选择收款账户" style="width: 100%">
                <el-option v-for="item in payAccountList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <!-- 收款日期 -->
            <el-form-item label="收款日期：" prop="payDate">
              <el-date-picker v-model="form.payDate" type="date" placeholder="请选择收款日期" style="width: 55%;margin-right:5px;"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <el-button plain type="primary" size="mini" @click="getYesterday('payDate')">昨天</el-button>
              <el-button plain type="primary" size="mini" @click="getToday('payDate')">今天</el-button>
            </el-form-item>

            <!-- 收款备注 -->
            <el-form-item label="收款备注：" prop="payRemark">
              <el-input v-model="form.payRemark" type="textarea" placeholder="请输入备注信息（最多500字符）" maxlength="500"
                rows="2"></el-input>
            </el-form-item>

            <!-- 附件上传 -->
            <el-form-item label="附件：">
              <el-upload class="billImage" :action="uploadUrl" :headers="uploadHeaders"
                :on-success="handleUploadSuccess" :on-remove="handleRemove" :on-preview="handlePreview"
                :before-upload="beforeUpload" :file-list="fileList" list-type="picture-card">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">支持图片、PDF等文件格式</div>
              </el-upload>
            </el-form-item>
          </div>
          <div class="rightDiv" v-if="!isOtherType">
            <!-- 首批物料备忘：醒目卡片置顶（文本与截图至少填一项） -->
            <div class="memoHighlightCard">
              <div class="memoHighlightHeader">
                <span class="memoHighlightTitle"><i class="el-icon-warning-outline"></i> 首批物料备忘</span>
                <span class="memoHighlightBadge">必填一项 · 同步筹建督导</span>
              </div>
              <el-form-item size="mini" label-width="0">
                <el-input size='mini' type="textarea" :rows="2" maxlength="200" v-model="form.firstMaterialMemo.text"
                  placeholder="请填写与客户约定的首批采购物料口径，如：首批物料金额7200元（老标准）"></el-input>
                <image-upload v-model="form.firstMaterialMemo.images" :limit="6" :active="true" @preview="handleMemoPreview" />
                <div class="memoTip">文本与截图至少填一项；支持点击/拖拽/Ctrl+V 粘贴上传截图（最多6张）</div>
              </el-form-item>
            </div>

            <!-- 附加信息（双列紧凑布局，压缩整页高度） -->
            <el-card shadow="never" class="additionalCard">
              <div class="additionalCardTitle">附加信息</div>
              <div class="additionalGrid">
                <el-form-item size="mini" label="评估单量：" label-width="120px" prop="additionalInfo.评估单量">
                  <el-input size='mini' v-model="form.additionalInfo['评估单量']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="客户签约代表：" label-width="120px" prop="additionalInfo.客户签约代表">
                  <el-input size='mini' v-model="form.additionalInfo['客户签约代表']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="联系电话：" label-width="120px" prop="additionalInfo.联系电话">
                  <el-input size='mini' v-model="form.additionalInfo['联系电话']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="店铺面积：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['店铺面积']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="店铺电力：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['店铺电力']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="店铺下水：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['店铺下水']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="燃气：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['燃气']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="房租：" label-width="120px" prop="additionalInfo.房租">
                  <el-input size='mini' v-model="form.additionalInfo['房租']" :placeholder="`填入0表示不确定`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="运费：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['运费']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="餐饮经验：" label-width="120px" prop="additionalInfo.餐饮经验">
                  <el-input size='mini' v-model="form.additionalInfo['餐饮经验']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="是否多开：" label-width="120px" prop="additionalInfo.是否多开">
                  <el-input size='mini' v-model="form.additionalInfo['是否多开']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="是否二店：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['是否二店']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="是否翻新：" label-width="120px" prop="additionalInfo.是否翻新">
                  <el-input size='mini' v-model="form.additionalInfo['是否翻新']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="商圈已测：" label-width="120px" prop="additionalInfo.商圈已测">
                  <el-input size='mini' v-model="form.additionalInfo['商圈已测']" :placeholder="`请填是或否`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="车尾交接：" label-width="120px">
                  <el-input size='mini' v-model="form.additionalInfo['车尾交接']" :placeholder="`请输入`"></el-input>
                </el-form-item>
                <el-form-item size="mini" label="情况说明：" label-width="120px" prop="additionalInfo.情况说明" class="gridSpan2">
                  <el-input size='mini' type="textarea" :rows="2" v-model="form.additionalInfo['情况说明']" :placeholder="`请输入情况说明`"></el-input>
                </el-form-item>
              </div>
            </el-card>
          </div>
        </div>

      </el-form>

    </el-card>

    <!-- 地图面板 -->
    <el-dialog title="选择坐标" :visible.sync="mapPreviewVisible" top="10vh" width="1000px" @opened='openMap'
      @close="closeMap">
      <div class="container">
        <div id="mapContainer"></div>
        <div id="mapText">
          <p>地址：{{ form.address }}</p>
          <p>大区：{{ form.area }}</p>
          <p>省份：{{ form.province }}</p>
          <p>城市：{{ form.city }}</p>
          <p>区县：{{ form.district }}</p>
          <p>纬度：{{ form.lat }}</p>
          <p>经度：{{ form.lng }}</p>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="mapPreviewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- PDF预览对话框 -->
    <el-dialog :visible.sync="pdfPreviewDialogVisible" width="60%" :title="previewTitle">
      <div class="preview-container" style="height: 600px;">
        <iframe :src="previewUrl" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-image v-show="false" ref="imageViewer" :src="currentImageUrl" :preview-src-list="imagePreviewList">
    </el-image>

  </div>
</template>

<script>
import { storeTypeList, mapKey, getAreaName, payAccountList, brandList, payTypeListForNew, rangeDefaults } from '@/utility/staticData'
import ImageUpload from '@/components/ImageUpload.vue'
export default {
  components: { ImageUpload },
  data () {
    return {
      accountInfo: {},
      // 签约人字段是否只读
      isSignerReadonly: false,
      // 提交中标志位（防重复点击）
      submitting: false,
      // 表单数据
      form: {
        projectName: '', // 项目名称
        customerId: '', // 客户ID
        customerName: '', // 客户名称
        signerId: '', // 签约人ID
        signerName: '', // 签约人姓名
        dealDate: '', // 签约时间
        signType: '', // 签约类型

        address: '', // 地址
        area: '', // 区域
        province: '', // 省份
        city: '', // 城市
        district: '', // 区县
        lat: '', // 纬度
        lng: '', // 经度

        supervisorId: '', // 督导ID
        supervisorName: '', // 督导姓名
        additionalInfo: {
          评估单量: '',
          客户签约代表: '',
          联系电话: '',
          店铺面积: '',
          店铺电力: '',
          店铺下水: '',
          燃气: '',
          房租: '',
          运费: '',
          餐饮经验: '',
          是否多开: '',
          是否二店: '',
          是否翻新: '',
          商圈已测: '',
          车尾交接: '',
          情况说明: ''
        },
        remark: '', // 备注

        contractAmount: 4980, // 合同金额
        commissionRate: 5, // 抽佣比例
        serviceStartDate: '', // 服务开始时间
        serviceEndDate: '', // 服务结束时间
        serviceDateRange: '', // 合同期限（用于校验）
        contractRemark: '', // 合同备注

        payType: '全款', // 钱款类型
        payAccount: '', // 支付账号
        totalAmount: '', // 总金额
        payDate: '', // 支付日期
        attachments: [], // 附件
        payRemark: '', // 收款备注
        range: 4, // 商圈范围（公里）
        // 首批物料备忘（text 文本 + images 截图相对路径数组）
        firstMaterialMemo: { text: '', images: [] }

      },

      // 员工列表
      employeeList: [],
      // 督导列表
      supervisorList: [],
      // 签约类型列表
      signTypeList: storeTypeList,
      // 钱款类型
      payTypeList: payTypeListForNew,
      // 收款账户
      payAccountList: payAccountList,

      // 表单验证规则
      formRules: {
        projectName: [
          { type: 'string', required: true, message: '请输入项目名称', trigger: 'blur' },
          { type: 'string', min: 2, max: 50, message: '项目名称必须为2-50个字符', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
              } else if (this.form.signType === '其他') {
                callback()
              } else {
                const startsWithBrand = brandList.some(brand => value.startsWith(brand))
                if (!startsWithBrand) {
                  callback(new Error('项目名称必须以品牌名称开头（如：美滋滋西安店)'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur'
          }
        ],
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        signerId: [
          { required: true, message: '请选择签约人', trigger: 'change' }
        ],
        dealDate: [
          { required: true, message: '请选择签约时间', trigger: 'change' }
        ],
        signType: [
          { required: true, message: '请选择签约类型', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        supervisorId: [
          { message: '请选择督导', trigger: 'change' }
        ],
        remark: [
          { type: 'string', max: 500, message: '备注信息不能超过500个字符', trigger: 'blur' }
        ],
        payRemark: [
          { type: 'string', max: 500, message: '收款备注信息不能超过500个字符', trigger: 'blur' }
        ],
        payType: { required: true, message: '请选择支付方式', trigger: 'change' },
        payAccount: { required: true, message: '请选择收款账户', trigger: 'change' },
        totalAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '金额不能为负数', trigger: 'blur' }
        ],
        payDate: { required: true, message: '请选择收款日期', trigger: 'change' },
        contractAmount: [
          { required: true, message: '请输入合同金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '合同金额不能为负数', trigger: 'blur' }
        ],
        commissionRate: [
          { required: true, message: '请输入抽佣比例', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '抽佣比例范围为0-100', trigger: 'blur' }
        ],
        serviceDateRange: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.form.serviceStartDate) {
                callback(new Error('请选择合同开始日期'))
              } else if (!this.form.serviceEndDate) {
                callback(new Error('请选择合同结束日期'))
              } else if (new Date(this.form.serviceStartDate) > new Date(this.form.serviceEndDate)) {
                callback(new Error('合同结束日期不能早于开始日期'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],

        additionalInfo: {
          评估单量: { required: true, message: '请输入评估单量', trigger: 'blur' },
          客户签约代表: { required: true, message: '请输入客户签约代表', trigger: 'blur' },
          联系电话: { required: true, message: '请输入联系电话', trigger: 'blur' },
          房租: { required: true, message: '请输入房租', trigger: 'blur' },
          餐饮经验: { required: true, message: '请输入餐饮经验', trigger: 'blur' },
          是否多开: { required: true, message: '请输入是否多开', trigger: 'blur' },
          是否翻新: { required: true, message: '请输入是否翻新', trigger: 'blur' },
          商圈已测: { required: true, message: '请填是或否，确定商圈不重叠', trigger: 'blur' },
          情况说明: { required: true, message: '请输入情况说明', trigger: 'blur' }
        }

      },

      // 地图相关
      map: null, // 地图对象
      script: null, // 脚本对象
      scriptLoading: null, // 脚本加载遮罩
      getAreaName: getAreaName, // 获取区域名称的方法
      mapPreviewVisible: false, // 地图预览可见性
      brandList: brandList, // 品牌列表

      // 上传使用
      uploadUrl: this.$http.defaults.baseURL + 'upload',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      fileList: [],

      // 预览相关
      pdfPreviewDialogVisible: false,
      previewUrl: '',
      previewTitle: '',
      currentImageUrl: '',
      imagePreviewList: [],

      // PDF 图标路径
      pdfIconUrl: require('@/assets/pdf.png'),

      // 用于预览的基础url
      base: ''

    }
  },
  computed: {
    isOtherType () {
      return this.form.signType === '其他'
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base')
    this.getAccountInfo()

    // 从路由参数获取客户信息
    const customerId = this.$route.query.customerId
    const customerName = decodeURIComponent(this.$route.query.customerName)
    const signerId = this.$route.query.signerId
    const signerName = decodeURIComponent(this.$route.query.signerName)
    if (customerId) {
      this.form.customerId = customerId
      this.form.customerName = customerName
      this.form.signerId = signerId
      this.form.signerName = signerName
    }
    // 先获取员工列表，再初始化签约人字段
    this.getEmployeeList().then(() => {
      this.initSignerField()
    })
    this.getSupervisorList()
    this.loadScript()
  },
  beforeDestroy () {
    this.unloadScript()
  },
  methods: {
    // 取得今天的日期
    getToday (formField) {
      this.form[formField] = this.$getDate(new Date())
    },

    // 取得昨天的日期
    getYesterday (formField) {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      this.form[formField] = this.$getDate(date)
    },

    // 加载地图脚本
    loadScript () {
      this.scriptLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      window.initMap = this.initMap
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${mapKey}&callback=initMap`
      document.body.appendChild(script)
      this.script = script
    },

    // 初始化地图
    initMap () {
      this.scriptLoading.close()
    },

    // 卸载地图脚本
    unloadScript () {
      if (this.script) {
        document.body.removeChild(this.script)
        this.script = null
        this.map = null
        delete window.TMap
        delete window.initMap
      }
    },

    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''
      this.accountInfo.bindDxqId = window.sessionStorage.getItem('bindDxqId') || ''
    },

    // 校验合同期限
    validateServiceDateRange () {
      this.$refs.formRef.validateField('serviceDateRange')
    },

    // 获取督导列表
    async getSupervisorList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/project/getSupervisors')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.supervisorList = res.data || []
      } catch (error) {
        this.$message.error('获取督导列表失败')
      }
    },

    // 获取员工列表
    async getEmployeeList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/customer/employees')
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return Promise.reject(new Error(res.meta.msg))
        }
        this.employeeList = res.data || []
        return Promise.resolve()
      } catch (error) {
        this.$message.error('获取员工列表失败')
        return Promise.reject(error)
      }
    },

    // 初始化签约人字段（根据用户角色设置默认值和可编辑状态）
    initSignerField () {
      const level = parseInt(this.accountInfo.level)
      const job = this.accountInfo.job
      const employeeId = this.accountInfo.employeeId

      // 管理员（level <= 1）：签约人默认为空，可编辑
      if (level <= 1) {
        this.isSignerReadonly = false
        return
      }

      // 普通员工、主管、总监：默认填充当前用户
      if (employeeId && this.employeeList.length > 0) {
        const currentEmployee = this.employeeList.find(item => item._id === employeeId)
        if (currentEmployee) {
          // 普通员工：只读
          if (job === '员工') {
            this.isSignerReadonly = true
          } else if (job === '主管' || job === '总监') {
            // 主管或总监：可编辑
            this.isSignerReadonly = false
          } else {
            // 其他情况默认可编辑
            this.isSignerReadonly = false
          }
        }
      }
    },

    // 签约人选择变化
    onSignerChange (value) {
      const signer = this.employeeList.find(item => item._id === value)
      if (signer) {
        this.form.signerName = signer.name
      }
    },

    // 督导选择变化
    onSupervisorChange (value) {
      const supervisor = this.supervisorList.find(item => item._id === value)
      if (supervisor) {
        this.form.supervisorName = supervisor.name
      }
    },

    // 签约类型变化，自动更新商圈范围默认值
    onSignTypeChange (value) {
      if (value && rangeDefaults[value] !== undefined) {
        this.form.range = rangeDefaults[value]
      }
      if (value === '其他') {
        this.form.commissionRate = 0
        this.form.payType = '全款'
        this.form.supervisorId = ''
        this.form.supervisorName = ''
        this.form.address = ''
        this.form.province = ''
        this.form.city = ''
        this.form.district = ''
        this.form.area = ''
        this.form.lat = ''
        this.form.lng = ''
        this.form.range = 5
        this.form.additionalInfo = {
          评估单量: '',
          客户签约代表: '',
          联系电话: '',
          店铺面积: '',
          店铺电力: '',
          店铺下水: '',
          燃气: '',
          房租: '',
          运费: '',
          餐饮经验: '',
          是否多开: '',
          是否二店: '',
          是否翻新: '',
          商圈已测: '',
          车尾交接: '',
          情况说明: ''
        }
      }
      this.$refs.formRef.validateField('projectName')
    },

    // 点击添加按钮
    async okClickHandler () {
      // 防止重复点击：提交中直接拦截
      if (this.submitting) return

      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        // 首批物料备忘：联合校验——文本与截图至少填一项（"其他"类型无此区块不校验）
        if (!this.isOtherType) {
          const memo = this.form.firstMaterialMemo
          if (!(memo.text && memo.text.trim()) && !memo.images.length) {
            return this.$message.error('请填写首批物料备忘：文本或截图至少提供一项')
          }
        }

        const submitData = {
          projectName: this.form.projectName,
          customerId: this.form.customerId,
          customerName: this.form.customerName,
          signerId: this.form.signerId,
          signerName: this.form.signerName,
          dealDate: this.form.dealDate,
          signType: this.form.signType,
          remark: this.form.remark || '',
          contractAmount: this.form.contractAmount,
          commissionRate: this.isOtherType ? 0 : this.form.commissionRate,
          serviceStartDate: this.form.serviceStartDate,
          serviceEndDate: this.form.serviceEndDate,
          contractRemark: this.form.contractRemark || '',
          payType: this.isOtherType ? '全款' : this.form.payType,
          payAccount: this.form.payAccount,
          totalAmount: this.form.totalAmount,
          payDate: this.form.payDate,
          attachments: this.form.attachments,
          payRemark: this.form.payRemark || ''
        }

        if (!this.isOtherType) {
          submitData.address = this.form.address
          submitData.province = this.form.province
          submitData.city = this.form.city
          submitData.district = this.form.district
          submitData.area = this.form.area
          submitData.lat = this.form.lat
          submitData.lng = this.form.lng
          submitData.supervisorId = this.form.supervisorId
          submitData.supervisorName = this.form.supervisorName
          submitData.additionalInfo = this.form.additionalInfo
          submitData.range = this.form.range
          // 首批物料备忘随表单提交
          submitData.firstMaterialMemo = {
            text: (this.form.firstMaterialMemo.text || '').trim(),
            images: this.form.firstMaterialMemo.images
          }
        }

        // console.log('提交数据：', submitData)

        // 进入提交中状态
        this.submitting = true
        try {
          const { data: res } = await this.$http.post('zhaoshang/project/add', submitData)
          if (res.meta.status !== 200) {
            this.$message.error(res.meta.msg)
            return false
          }
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          console.error('添加项目失败:', error)
          this.$message.error('添加项目失败')
        } finally {
          // 无论成功失败，释放提交状态
          this.submitting = false
        }
      })
    },

    // 点击定位按钮
    async locateClickHandler () {
      if (!this.form.address) {
        return this.$message.error('请先输入地址')
      }
      try {
        const { data: res } = await this.$http.get('map/geocoder', {
          params: {
            address: this.form.address
          }
        })

        if (res.meta.status === 200) {
          this.form.province = res.data.address_components.province
          this.form.city = res.data.address_components.city
          this.form.district = res.data.address_components.district
          this.form.lat = res.data.location.lat
          this.form.lng = res.data.location.lng
          this.form.area = this.getAreaName(this.form.province)
          this.mapPreviewVisible = true
          this.$message.success('定位成功')
        } else {
          this.$message.error(res.meta.msg || '定位失败，请检查地址是否正确')
        }
      } catch (error) {
        console.log('定位失败:', error)
        this.$message.error('定位失败，请检查地址是否正确')
      }
    },

    // 地图打开
    openMap () {
      const center = new window.TMap.LatLng(this.form.lat, this.form.lng)

      this.map = new window.TMap.Map('mapContainer', {
        center: center,
        zoom: 13,
        viewMode: '2D',
        showControl: false
      })
      this.marker = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          // 点标记样式
          marker: new window.TMap.MarkerStyle({
            width: 40, // 样式宽
            height: 60, // 样式高
            anchor: { x: 20, y: 60 } // 描点位置
          })
        }
      })
      this.marker.add({
        id: 'mark',
        styleId: 'marker',
        position: new window.TMap.LatLng(this.form.lat, this.form.lng)
      })
    },

    // 地图关闭
    closeMap () {
      this.map.destroy()
    },

    // 判断文件类型
    getFileType (fileName) {
      const ext = fileName.toLowerCase().split('.').pop()
      const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      const pdfExts = ['pdf']

      if (imageExts.includes(ext)) return 'image'
      if (pdfExts.includes(ext)) return 'pdf'
      return 'other'
    },

    // 备忘截图预览（复用附件同款大图查看器，支持多图切换；ImageUpload 的 preview 事件给完整 URL）
    handleMemoPreview (imageUrl) {
      if (!imageUrl) return
      const base = window.sessionStorage.getItem('base') || ''
      this.imagePreviewList = this.form.firstMaterialMemo.images.map(u => (/^(https?:|data:|blob:)/.test(u) ? u : base + u))
      this.currentImageUrl = imageUrl
      this.$nextTick(() => {
        this.$refs.imageViewer.clickHandler()
      })
    },

    // 上传前校验
    beforeUpload (file) {
      const fileType = this.getFileType(file.name)
      const isValidType = ['image', 'pdf'].includes(fileType)

      if (!isValidType) {
        this.$message.error('只支持上传图片或PDF文件')
        return false
      }

      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!')
        return false
      }

      return true
    },

    // 上传成功
    handleUploadSuccess (res, file, fileList) {
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      const fileType = this.getFileType(file.name)
      const baseUrl = this.base

      // 为PDF文件设置自定义图标
      if (fileType === 'pdf') {
        const fileItem = fileList[fileList.length - 1]
        fileItem.url = this.pdfIconUrl // 用于显示图标
        fileItem.actualUrl = baseUrl + res.data.url // 保存实际文件地址用于预览
      }

      this.form.attachments.push({
        url: res.data.url,
        name: file.name,
        type: fileType
      })
      this.fileList = fileList
    },

    // 删除文件
    handleRemove (file, fileList) {
      const index = this.fileList.indexOf(file)
      if (index !== -1 && this.form.attachments[index]) {
        this.form.attachments.splice(index, 1)
      }
      this.fileList = fileList
    },

    // 预览文件
    handlePreview (file) {
      const attachment = this.form.attachments.find(item => item.name === file.name)
      if (!attachment) return

      const baseUrl = this.base
      const fileUrl = baseUrl + attachment.url

      console.log(fileUrl)

      this.previewTitle = file.name

      if (attachment.type === 'image') {
        // 使用 Element UI 的图片预览
        this.buildImagePreviewList()
        this.currentImageUrl = fileUrl
        this.$nextTick(() => {
          this.$refs.imageViewer.clickHandler()
        })
      } else if (attachment.type === 'pdf') {
        // PDF使用对话框预览
        this.previewUrl = file.actualUrl || fileUrl
        this.pdfPreviewDialogVisible = true
      }
    },

    // 构建图片预览列表
    buildImagePreviewList () {
      const baseUrl = this.base
      this.imagePreviewList = this.form.attachments
        .filter(item => item.type === 'image')
        .map(item => baseUrl + item.url)
    },

    // 返回
    goBack () {
      // 获取传递过来的状态参数
      const query = { ...this.$route.query }
      delete query.customerId
      delete query.customerName
      delete query.signerId
      delete query.signerName

      // 构建返回URL
      const queryString = Object.keys(query).length > 0
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
        : '?tabs=project'

      this.$router.push('/zhaoshang/customer' + queryString)
    }
  }
}
</script>

<style lang="less" scoped>
.divContainer {
  display: flex;
  gap: 20px;
}

.leftDiv {
  width: 370px;
  // background-color: #8eb1e6;
}

.midDiv {
  width: 420px;
  // background-color: #daf579;
}

.rightDiv {
  width: 620px;
  // background-color: #ee90db;
}

// 备忘醒目卡片（置顶必见）
.memoHighlightCard {
  background: linear-gradient(135deg, #FFFCF7 0%, #FDF6EC 100%);
  border: 1px solid #F3D9A4;
  border-left: 4px solid #E6A23C;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(230, 162, 60, 0.12);

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
.memoHighlightHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.memoHighlightTitle {
  font-size: 14px;
  font-weight: bold;
  color: #B88230;

  i {
    margin-right: 4px;
  }
}
.memoHighlightBadge {
  background: #E6A23C;
  color: #fff;
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 10px;
  white-space: nowrap;
}

// 附加信息双列紧凑网格（压缩整页高度，一屏显示）
.additionalCard {
  background-color: #f5f7fa;
}
.additionalCardTitle {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
}
.additionalGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 14px;

  ::v-deep .el-form-item {
    margin-bottom: 10px;
  }
}
.gridSpan2 {
  grid-column: 1 / -1;
}

.descText {
  font-size: 12px;
  color: #999;
}

.container {
  display: flex;
}

#mapContainer {
  height: 600px;
  width: 600px;
}

#mapText {
  padding: 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #999;
}

.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

// 自定义上传列表中的PDF图标样式
::v-deep .el-upload-list__item-thumbnail {
  object-fit: contain;
}

// 图片预览样式优化
::v-deep .el-image-viewer__wrapper {
  z-index: 3000;
}
</style>
<style>
.billImage .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.billImage .el-upload-list__item {
  width: 100px !important;
  height: 100px !important;
}

/* 备忘截图上传（ImageUpload 组件，督导端同款，支持粘贴） */
.memoHighlightCard .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

.memoHighlightCard .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}

.memoTip {
  font-size: 12px;
  color: #E6A23C;
  line-height: 1.6;
  margin-top: 4px;
}
</style>
